import * as React from "react";
import { useSelector } from "react-redux";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router";
import { Divider, Form, Input, Radio, Select, Switch, Tooltip } from "antd";
import axios from "axios";
import { responseNotification } from "../../utils/notify";
import { ImageUploader, SubmitResetBtn } from "../common";
import { QuestionCircleOutlined } from "@ant-design/icons";
import BreadCrumb from "../Layouts/Breadcrumb";
import { debounce } from "lodash";

export default function PersonalDetails() {
  const { token, shopInfo } = useSelector(
    (state) => (state as any)?.authReducer
  );
  const navigate = useNavigate();
  const [error, setError] = useState("");

  const [merchantShopCheck, setMerchantShopCheck] = useState<any>();
  const shopId = merchantShopCheck?.[0]?.id || 0;
  const [mobileBankingType, setMobileBankingType] = useState<any>("BKASH");
  const [generatedImgUrl, setGeneratedImgUrl] = useState<string>();
  const [loading, setLoading] = useState(false);
  const [bankType, setBankType] = useState("BANKING");
  const [bankId, setBankId] = useState<any>();
  const [isDefault, setIsDefault] = useState(false);
  const [shopData, setShopData] = useState<any>(undefined);
  const [key, setKey] = useState("");
  const [startUpload, setStartUpload] = useState<
    "Initiated" | "Uploading" | "Uploaded"
  >();
  const [bankOptions, setBankOptions] = useState({
    loading: false,
    list: [],
    raw: [],
  });

  const [branchOptions, setBranchOptions] = useState<any[]>([]);
  const [selectedBankId, setSelectedBankId] = useState<string | null>(null);
  const [branchId, setBranchId] = useState<any>();
  const [singleMerchantInfo, setSingleMerchantInfo] = useState<any>({
    loading: false,
    data: null,
  });
  const [form] = Form.useForm();

  useEffect(() => {
    if (startUpload === "Uploaded") {
      form.submit();
    }
  }, [form, startUpload]);


  const onSubmit = async (data: any) => {
    setLoading(true);
    const readyData = data && {
      bankingType: bankType,
      accountName: `${data.accountName}`,
      accountNumber: `${data.accountNumber}`,
      bankName: selectedBankId,
      branchName: branchId,
      routingNumber: `${data.routingNumber}`,
      isDefault: isDefault,
      shopId: shopId,
      uploadBankChequeCopy: generatedImgUrl ? generatedImgUrl : "",
    };

    if (singleMerchantInfo?.data?.[0]) {
      await fetch(
        `${process.env.REACT_APP_CATALOG_WRITER_API}/shop-bank/update-bank`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ...readyData,
            id: shopData?.id,
          }),
        }
      )
        .then((res) => res.json())
        .then((res) => {
          setLoading(false);

          if (res.statusCode === 200) {
            responseNotification("Updated Successfully", "success");
            form.resetFields();
            navigate("/merchant-profile");
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          setLoading(false);
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    } else {
      await fetch(
        `${process.env.REACT_APP_CATALOG_WRITER_API}/shop-bank/add-bank`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(readyData),
        }
      )
        .then((res) => res.json())
        .then((res) => {
          setLoading(false);

          if (res.statusCode === 200) {
            responseNotification("Create Successfully", "success");
            form.resetFields();
            navigate("/merchant-profile");
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          setLoading(false);
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    }
  };

  


  const getMerchantShopCheck = useCallback(async () => {
    const res = await axios.get(
      `${process.env.REACT_APP_CATALOG_READER_API}/merchant/all-shops-by-merchant`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    setMerchantShopCheck(res?.data?.shops);
  }, []);

  const fetchMerchantDetails = useCallback(() => {
    try {
      setSingleMerchantInfo({ loading: true, data: null });
      axios
        .get(
          `${process.env.REACT_APP_CATALOG_WRITER_API}/shop-bank/getAllBank?shopId=${shopId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        )
        .then((data) => {
          if (data.status === 200) {
            setSingleMerchantInfo({
              loading: false,
              data: data?.data?.shopBanks,
            });
          } else {
            setSingleMerchantInfo({ loading: false, data: null });
            responseNotification(
              data.statusText || "something went wrong",
              "error"
            );
          }
        })
        .catch((err) => {
          setSingleMerchantInfo({ loading: false, data: null });
        });
    } catch (error) {
      setSingleMerchantInfo({ loading: false, data: null });
    }
  }, [shopId]);

  const getBankOptions = useCallback(
    async (key?: string) => {
      setBankOptions({ loading: true, list: [], raw: [] });

      const encodedUri = `${process.env.REACT_APP_PAY_API}`;
      let url = `?page=0&limit=20` + (key ? `&key=${key}` : ``);
      url = encodeURI(url);

      try {
        const res = await axios.get(`${encodedUri}/bank${url}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const banks = res.data?.banks || [];

        setBankOptions({
          loading: false,
          raw: banks, // 🔥 full data
          list: banks.map((bank: any) => ({
            label: bank.name,
            value: bank.id,
          })),
        });
      } catch (err) {
        setBankOptions({ loading: false, list: [], raw: [] });
        console.error("Bank Error", err);
      }
    },
    [key]
  );

  const fetchRef = useRef(0);
  const handleSearch = useMemo(() => {
    const loadOptions = (value: string, field: string) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;

      if (fetchId !== fetchRef.current) {
        return;
      }
      if (value) {
        if (field === "bank") getBankOptions(value);
      }
    };

    return debounce(loadOptions, 800);
  }, [getBankOptions]);

  const handleBankChange = (bankId: string) => {
    setSelectedBankId(bankId);

    const selectedBank = bankOptions.raw.find(
      (bank: any) => bank.id === bankId
    );

    const branches = selectedBank?.branches || [];

    setBranchOptions(
      branches.map((branch: any) => ({
        label: branch.name,
        value: branch.id,
      }))
    );

    form.setFieldsValue({ branchId: undefined });
  };

  useEffect(() => {
    fetchMerchantDetails();
    getBankOptions("");
  }, [fetchMerchantDetails, getBankOptions, shopId]);

  useEffect(() => {
    getMerchantShopCheck();
  }, [getMerchantShopCheck]);

  useEffect(() => {
    if (singleMerchantInfo?.data) {
      form.resetFields();
      // setBankType(singleMerchantInfo?.data?.[0]?.bankingType);
      setIsDefault(singleMerchantInfo?.data?.[0]?.isDefault);
      setGeneratedImgUrl(singleMerchantInfo?.data?.[0]?.uploadBankChequeCopy);
    }
  }, [form, singleMerchantInfo?.data]);
  return (
    <div className="flex overflow-hidden flex-col bg-stone-50 pb-[740px] max-md:pb-24">
      <main className="flex flex-col self-center mt-5 max-w-full w-[50%]">
        <BreadCrumb
          title="Add Bank Account"
          className="flex gap-2 bg-red-700 text-base font-bold text-zinc-800"
        />

        <Form
          name="control-hooks"
          onFinish={onSubmit}
          form={form}
          layout="vertical"
          className="flex flex-col items-start pt-8 pr-20 pb-12 pl-8 mt-2.5 w-full bg-white rounded-md shadow-sm max-md:px-5 max-md:max-w-full"
          initialValues={{
            ...singleMerchantInfo?.data?.[0],
            accountName: singleMerchantInfo?.data?.[0]?.accountName || "",
            accountNumber: singleMerchantInfo?.data?.[0]?.accountNumber || "",
            name: singleMerchantInfo?.data?.[0]?.name || "",
            branchName: singleMerchantInfo?.data?.[0]?.branchName || "",
            routingNumber: singleMerchantInfo?.data?.[0]?.routingNumber || "",
          }}
        >
          <div className="flex justify-between border-b pb-3 mb-8 border-gray-100">
            <Form.Item name="bankType" initialValue={bankType}>
              <Radio.Group
                value={bankType}
                onChange={(e) => {
                  setBankType(e.target.value);
                  form.setFieldsValue({ bankType: e.target.value });
                }}
              >
                <Radio value="BANKING">BANK</Radio>
                <Radio value="MOBILE_BANKING">MOBILE BANKING (MFS)</Radio>
              </Radio.Group>
            </Form.Item>
          </div>
          <div className="grid grid-cols-2 gap-4">
            {bankType === "MOBILE_BANKING" && (
              <>
                <Form.Item
                  hasFeedback
                  label="Mobile Banking Type"
                  name="businessOperationType"
                  rules={[
                    {
                      required: true,
                      message: "Mobile Banking Type is required!",
                    },
                  ]}
                >
                  <Select
                    defaultValue={mobileBankingType}
                    onChange={(val) => setMobileBankingType(val)}
                    options={[
                      {
                        value: "BKASH",
                        label: "BKASH",
                      },
                      {
                        value: "NAGAD",
                        label: "NAGAD",
                      },
                    ]}
                  />
                </Form.Item>
                <Form.Item
                  name="accountNumber"
                  hasFeedback
                  label="Mobile Number"
                  rules={[
                    {
                      required: true,
                      message: "Mobile Number is Required!",
                    },
                  ]}
                >
                  <Input
                    id="accountNumber"
                    type="text"
                    className="input-box"
                    placeholder="Enter account number"
                  />
                </Form.Item>
                <Form.Item
                  name="accountName"
                  hasFeedback
                  label="Full Name"
                  rules={[
                    {
                      required: true,
                      message: "Full Name is Required!",
                    },
                  ]}
                >
                  <Input
                    type="text"
                    id="accountName"
                    className="input-box"
                    placeholder="Enter account name"
                  />
                </Form.Item>
              </>
            )}

            {bankType === "BANKING" && (
              <>
                <Form.Item
                  name="accountName"
                  hasFeedback
                  label="Account Name"
                  rules={[
                    {
                      required: true,
                      message: "Account Name is Required!",
                    },
                  ]}
                >
                  <Input
                    type="text"
                    id="accountName"
                    className="input-box"
                    placeholder="Enter account name"
                  />
                </Form.Item>

                <Form.Item
                  name="accountNumber"
                  hasFeedback
                  label="Account Number"
                  rules={[
                    {
                      required: true,
                      message: "Account Number is Required!",
                    },
                  ]}
                >
                  <Input
                    id="accountNumber"
                    type="text"
                    className="input-box"
                    placeholder="Enter account number"
                  />
                </Form.Item>
                <Form.Item
                  name="bankId"
                  label="Bank"
                  rules={[{ required: true }]}
                >
                  <Select
                    allowClear
                    showSearch
                    placeholder="Select Bank"
                    loading={bankOptions.loading}
                    options={bankOptions.list}
                    onChange={handleBankChange}
                    onSearch={(e) => getBankOptions(e)}
                    filterOption={false}
                  />
                </Form.Item>

                <Form.Item
                  name="branchId"
                  label="Branch"
                  rules={[{ required: true }]}
                >
                  <Select
                    allowClear
                    showSearch
                    placeholder={
                      selectedBankId ? "Select Branch" : "Select Bank First"
                    }
                    onChange={(val) => setBranchId(val)}
                    disabled={!selectedBankId}
                    options={branchOptions}
                  />
                </Form.Item>

                <Form.Item
                  name="routingNumber"
                  hasFeedback
                  label="Routing Number"
                  rules={[
                    {
                      required: true,
                      message: "Routing Number is Required!",
                    },
                  ]}
                >
                  <Input
                    id="routingNumber"
                    type="text"
                    className="input-box"
                    placeholder="Enter routing number"
                  />
                </Form.Item>
              </>
            )}
            <Form.Item
              hasFeedback
              label="is Defaul?"
              name="isDefault"
              style={{ minWidth: "100%" }}
            >
              <Switch
                checkedChildren="Yes"
                unCheckedChildren="No"
                defaultChecked={isDefault}
                onChange={setIsDefault}
              />
            </Form.Item>
            {bankType === "BANKING" && (
              <>
                <div className="mr-4">
                  <Divider orientation="left">
                    {bankType === "BANKING" && <>Upload Bank Cheque Copy</>}
                    {bankType === "MOBILE_BANKING" && <>Logo</>}

                    <Tooltip
                      placement="bottom"
                      title={
                        "Upload Bank Cheque Copy should be square. We prefer height 200px and width 200px (Ratio 1)"
                      }
                    >
                      <QuestionCircleOutlined className="px-2 -mt-2" />
                    </Tooltip>
                  </Divider>

                  <ImageUploader
                    imgUrl={generatedImgUrl || ""}
                    startUpload={startUpload}
                    setStartUpload={(val: any) => setStartUpload(val)}
                    setGeneratedImgUrl={(url: any) => setGeneratedImgUrl(url)}
                    // crop={cropImage ? 2.5 : 0}
                  />
                </div>
              </>
            )}
          </div>
          <SubmitResetBtn
            onClickSubmit={(e) => {
              e.preventDefault();
              setStartUpload("Uploading");
            }}
            onClickReset={() => {
              form?.resetFields();
              setGeneratedImgUrl(undefined);
              setStartUpload(undefined);
              // setCountryUrl(undefined);
            }}
            disabled={loading || !!error}
            loading={loading}
          />
        </Form>
      </main>
    </div>
  );
}
